// ABOUTME: Resolves visible multi-step view tabs after metadata fields are filtered.
// ABOUTME: Keeps selected tab content aligned with the tab shown to users.
export interface MainViewVisibleStep {
    step: Compleo.IObject;
    stepIndex: number;
}

export const getMainViewVisibleSteps = (
    steps: Compleo.IObject[],
    visibleStepIds: string[]
): MainViewVisibleStep[] => {
    return (steps || []).reduce<MainViewVisibleStep[]>(
        (visibleSteps, step, index) => {
            if (visibleStepIds.includes(step.id)) {
                visibleSteps.push({
                    step,
                    stepIndex: index
                });
            }
            return visibleSteps;
        },
        []
    );
};

export const resolveMainViewSelectedStepIndex = (
    visibleSteps: MainViewVisibleStep[],
    selectedStepIndex: number
) => {
    if (visibleSteps.some((item) => item.stepIndex === selectedStepIndex)) {
        return selectedStepIndex;
    }

    const nextVisibleStep = visibleSteps.find(
        (item) => item.stepIndex > selectedStepIndex
    );
    if (nextVisibleStep) {
        return nextVisibleStep.stepIndex;
    }

    return visibleSteps[visibleSteps.length - 1]?.stepIndex || 0;
};

export const resolveMainViewRequestedStepIndex = (
    visibleSteps: MainViewVisibleStep[],
    requestedStepId?: string,
    handledStepId?: string
) => {
    if (!requestedStepId || handledStepId === requestedStepId) {
        return undefined;
    }

    return visibleSteps.find((item) => item.step.id === requestedStepId)
        ?.stepIndex;
};
